module.exports = {"return":{"minions_pre":[],"minions_rejected":[],"minions_denied":[],"local":["master.pem","master.pub"],"minions":["homer.bardels.me","jmini.bardels.me","lisa.bardels.me","maggie.bardels.me","osmc.tirana"]}}


//////////////////
// WEBPACK FOOTER
// ./src/fixtures/keys.json
// module id = 1056
// module chunks = 0